module.exports = __webpack_public_path__ + "img/icon3.fc0da89e.svg";